<form [formGroup]="sftpForm" class="sftp-config" [ngClass]="{ 'sftp-config--wrapped': props.wrappedStyles }">
    @if (!props.hideHeader) {
        <h4 class="header">{{ key }}</h4>
    }
    <div class="host">
        @if (hasField('Host')) {
            <mat-form-field appearance="fill">
                <mat-label>Server URL</mat-label>
                <input matInput formControlName="Host" />
                <mat-hint>SFTP server URL address.</mat-hint>
                <mat-error>
                    <ng-container [ngTemplateOutlet]="fieldErrors" [ngTemplateOutletContext]="{ control: 'Host' }"></ng-container>
                </mat-error>
            </mat-form-field>
        }

        @if (hasField('Port')) {
            <mat-form-field appearance="fill">
                <mat-label>Port</mat-label>
                <input matInput type="number" formControlName="Port" />
                <mat-error>
                    <ng-container [ngTemplateOutlet]="fieldErrors" [ngTemplateOutletContext]="{ control: 'Port' }"></ng-container>
                </mat-error>
            </mat-form-field>
        }
    </div>

    @if (hasField('RemoteFolder')) {
        <mat-form-field appearance="fill">
            <mat-label>Remote folder</mat-label>
            <input matInput formControlName="RemoteFolder" />
            <mat-hint>Remote folder path.</mat-hint>
            <mat-error>
                <ng-container [ngTemplateOutlet]="fieldErrors" [ngTemplateOutletContext]="{ control: 'RemoteFolder' }"></ng-container>
            </mat-error>
        </mat-form-field>
    }

    <div class="credentials">
        @if (hasField('Username')) {
            <mat-form-field appearance="fill">
                <mat-label>Username</mat-label>
                <input matInput formControlName="Username" />
                <mat-error>
                    <ng-container [ngTemplateOutlet]="fieldErrors" [ngTemplateOutletContext]="{ control: 'Username' }"></ng-container>
                </mat-error>
            </mat-form-field>
        }

        @if (hasField('Password')) {
            <mat-form-field appearance="fill">
                <mat-label>Password</mat-label>
                <input matInput type="password" formControlName="Password" />
                <mat-error>
                    <ng-container [ngTemplateOutlet]="fieldErrors" [ngTemplateOutletContext]="{ control: 'Password' }"></ng-container>
                </mat-error>
            </mat-form-field>
        }
    </div>
    @if (props.enableConnectionTest) {
        <div class="connection-test">
            <ng-container *ngrxLet="store.connectionTestStatus$; let connectionTestStatus">
                <button mat-stroked-button (click)="testConnection()" [disabled]="connectionTestStatus === 'in-progress'">TEST CONNECTION</button>
                @switch (connectionTestStatus) {
                    @case ('in-progress') {
                        <small class="connection-test__result">Testing connection...</small>
                    }
                    @case ('success') {
                        <small class="connection-test__result color-primary--force">Connection successful.</small>
                    }
                    @case ('error') {
                        <small class="connection-test__result color-warn--force">Error connecting to SFTP server.</small>
                    }
                    @case ('timeout') {
                        <small class="connection-test__result color-warn--force">Connection timed out.</small>
                    }
                    @case ('unauthorized') {
                        <small class="connection-test__result color-warn--force">Authentication error.</small>
                    }
                }
            </ng-container>
        </div>
    }
</form>

<ng-template #fieldErrors let-control="control">
    @if (sftpForm.get(control).hasError('pattern')) {
        Invalid character pattern {{ sftpForm.get(control).getError('pattern') }}
    }
    @if (sftpForm.get(control).hasError('required')) {
        This field is required.
    }
    @if (sftpForm.get(control).hasError('minLength')) {
        Must have at least {{ sftpForm.get(control).getError('minLength').minLength }} characters.
    }
    @if (sftpForm.get(control).hasError('maxLength')) {
        Cannot have more than {{ sftpForm.get(control).getError('maxLength').maxLength }} characters.
    }
    @if (sftpForm.get(control).hasError('min')) {
        Must be greater than {{ sftpForm.get(control).getError('min').min }}.
    }
    @if (sftpForm.get(control).hasError('max')) {
        Cannot be greater than {{ sftpForm.get(control).getError('max').max }}.
    }
</ng-template>
